<template>
  <div>
    <v-card class="main-card">
      <v-tabs v-model="tab">
        <v-tab>درخواست محصولات</v-tab>
        <v-tab>درخواست خدمات</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <div class="d-flex justify-space-between mt-5">
            <div>
              <p class="fs-xlarge">
                لیست خریدها
                <span v-if="purchases.length" class="fs-medium grey--text"
                  >({{ purchases.length }} عدد)</span
                >
              </p>
            </div>
            <div>
              <v-btn color="error" @click="$router.go(-1)">بازگشت</v-btn>
            </div>
          </div>
          <div class="mt-10">
            <!-- TABLE -->
            <template>
              <div class="custom-table">
                <v-data-table
                  :mobile-breakpoint="0"
                  :headers="headers"
                  :items="computedPurchases"
                  :page.sync="CurrentPage"
                  :items-per-page="PerPage"
                  :hide-default-footer="true"
                  :loading="tableLoading"
                  loading-text="در حال بارگذاری اطلاعات..."
                >
                  <template v-slot:top>
                    <v-row class="mb-4 mt-1">
                      <v-col cols="12">
                        <v-text-field
                          v-model="searchField"
                          placeholder="جستجو..."
                          filled
                          rounded
                          hide-details
                          id="search-field"
                        >
                          <template v-slot:prepend-inner>
                            <div class="me-5">
                              <v-icon
                                v-if="searchField"
                                color="grey"
                                style="margin-top: 1px"
                                @click="searchField = ''"
                                >mdi-close</v-icon
                              >
                            </div>
                            <div>
                              <v-icon>mdi-magnify</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </template>
                  <!-- End Search-->
                  <template slot="no-data">
                    <div class="font-weight-bold">
                      موردی برای نمایش وجود ندارد!
                    </div>
                  </template>

                  <template v-slot:[`item.userName`]="{ item }">
                    <span
                      v-if="item.userName"
                      v-html="computedText(item.userName)"
                    ></span>
                  </template>

                  <template v-slot:[`item.price`]="{ item }">
                    {{
                      item.price ? item.price.toLocaleString() + " تومان" : "-"
                    }}
                  </template>

                  <template v-slot:[`item.productName`]="{ item }">
                    <span
                      v-if="item.productName"
                      v-html="computedText(item.productName)"
                    ></span>
                  </template>

                  <template v-slot:[`item.userMobile`]="{ item }">
                    <span
                      v-if="item.userMobile"
                      v-html="computedText(item.userMobile)"
                    ></span>
                  </template>

                  <template v-slot:[`item.date`]="{ item }">
                    <span
                      v-if="item.date"
                      v-html="computedText(item.date)"
                    ></span>
                  </template>

                  <template v-slot:[`item.status`]="{ item }">
                    <span
                      v-if="item.status"
                      v-html="computedText(item.status)"
                    ></span>
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    <div v-if="item.status == 'در حال بررسی'">
                      <v-btn
                        @click="openApproveDialog(item)"
                        color="teal"
                        class="white--text me-2"
                        width="70"
                      >
                        تایید
                      </v-btn>

                      <v-btn
                        color="error"
                        width="70"
                        @click="openRejectDialog(item)"
                      >
                        رد
                      </v-btn>
                    </div>
                    <q v-else class="grey--text">بدون عملیات</q>
                  </template>
                </v-data-table>
                <v-pagination
                  v-model="CurrentPage"
                  :length="Math.ceil(computedPurchases.length / PerPage)"
                  :total-visible="5"
                  prev-icon="mdi-arrow-left"
                  next-icon="mdi-arrow-right"
                  class="mt-8"
                ></v-pagination>
              </div>
            </template>
          </div>
        </v-tab-item>
        <!--requests-->
        <v-tab-item>
          <div class="d-flex justify-space-between mt-5">
            <div>
              <p class="fs-xlarge">
                لیست درخواست‌ها
                <span v-if="requests.length" class="fs-medium grey--text"
                  >({{ requests.length }} عدد)</span
                >
              </p>
            </div>
            <div>
              <v-btn color="error" @click="$router.go(-1)">بازگشت</v-btn>
            </div>
          </div>
          <div class="mt-10">
            <!-- TABLE -->
            <template>
              <div class="custom-table">
                <v-data-table
                  :mobile-breakpoint="0"
                  :headers="headersRequest"
                  :items="computedRequests"
                  :page.sync="CurrentPageRequests"
                  :items-per-page="PerPageRequests"
                  :hide-default-footer="true"
                  :loading="tableLoading"
                  loading-text="در حال بارگذاری اطلاعات..."
                >
                  <template v-slot:top>
                    <v-row class="mb-4 mt-1">
                      <v-col cols="12">
                        <v-text-field
                          v-model="searchField"
                          placeholder="جستجو..."
                          filled
                          rounded
                          hide-details
                          id="search-field"
                        >
                          <template v-slot:prepend-inner>
                            <div class="me-5">
                              <v-icon
                                v-if="searchField"
                                color="grey"
                                style="margin-top: 1px"
                                @click="searchField = ''"
                                >mdi-close</v-icon
                              >
                            </div>
                            <div>
                              <v-icon>mdi-magnify</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </template>
                  <!-- End Search-->
                  <template slot="no-data">
                    <div class="font-weight-bold">
                      موردی برای نمایش وجود ندارد!
                    </div>
                  </template>

                  <template v-slot:[`item.userName`]="{ item }">
                    <span
                      v-if="item.userName"
                      v-html="computedText(item.userName)"
                    ></span>
                  </template>

                  <template v-slot:[`item.status`]="{ item }">
                    <span
                      v-if="item.status"
                      v-html="computedText(item.status)"
                    ></span>
                  </template>

                  <template v-slot:[`item.businessType`]="{ item }">
                    <span>{{
                      activityTypes.filter(
                        (a) => a.value == item.businessType
                      )[0]
                        ? activityTypes.filter(
                            (a) => a.value == item.businessType
                          )[0].text
                        : "-"
                    }}</span>
                  </template>

                  <template v-slot:[`item.status`]="{ item }">
                    <span>{{
                      statuses.filter((a) => a.value == item.status)[0]
                        ? statuses.filter((a) => a.value == item.status)[0].text
                        : "-"
                    }}</span>
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    <v-btn class="primary" @click="getRequestInfo(item)"
                      >جزییات</v-btn
                    >
                  </template>
                </v-data-table>
                <v-pagination
                  v-model="CurrentPageRequests"
                  :length="Math.ceil(computedRequests.length / PerPageRequests)"
                  :total-visible="5"
                  prev-icon="mdi-arrow-left"
                  next-icon="mdi-arrow-right"
                  class="mt-8"
                ></v-pagination>
              </div>
            </template>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <!-- Dialog for approve confirmation -->
    <v-dialog v-model="approveDialog" width="600">
      <v-card class="modal-card">
        <v-card-title class="py-0">
          <div class="text-right fs-xlarge grey--text text--darken-3">
            تایید درخواست خرید
          </div>
        </v-card-title>
        <v-card-text class="pb-2">
          <v-divider class="my-4"></v-divider>
          <div class="text-right">
            <div class="grey--text text--darken-1 mb-2">
              <v-icon>mdi-circle-medium</v-icon><b>نام خریدار:</b>
              {{ selected.userName }}
            </div>
            <div class="grey--text text--darken-1 mb-2">
              <v-icon>mdi-circle-medium</v-icon><b>نام محصول:</b>
              {{ selected.productName }}
            </div>
            <div class="grey--text text--darken-1 mb-2">
              <v-icon>mdi-circle-medium</v-icon><b>قیمت محصول:</b>
              {{ selected.price ? selected.price.toLocaleString() : 0 }} تومان
            </div>
            <div class="grey--text text--darken-1 mb-5">
              <v-icon>mdi-circle-medium</v-icon><b>تاریخ خرید:</b>
              {{ selected.date }}
            </div>
            <div class="grey--text text--darken-1 mb-4">
              <v-text-field
                v-model="selected.amount"
                placeholder="تعداد خریداری شده"
                label="تعداد خریداری شده"
                outlined
                hide-details
                dense
              ></v-text-field>
            </div>
            <div class="fs-large teal--text text--darken-1 mb-5">
              <b>مبلغ کل:</b>
              {{ (selected.price * selected.amount).toLocaleString() }} تومان
            </div>

            <b class="grey--text text--darken-4 fs-medium">
              آیا از تایید درخواست ثبت شده اطمینان دارید؟
            </b>
          </div>

          <div class="text-left pt-4">
            <v-btn
              width="80"
              height="42"
              class="rounded-lg teal me-3 white--text"
              @click="confirmApprove()"
              :loading="loading"
              ><v-icon small class="me-2">mdi-check-underline</v-icon>بله</v-btn
            >
            <v-btn
              width="80"
              height="42"
              class="rounded-lg error"
              @click="approveDialog = false"
              ><v-icon small class="me-2">mdi-close</v-icon>خیر</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Dialog for approve Consultation -->
    <v-dialog v-model="approveDialog" width="600">
      <v-card class="modal-card">
        <v-card-title class="py-0">
          <div class="text-right fs-xlarge grey--text text--darken-3">
            تایید درخواست خدمت
          </div>
        </v-card-title>
        <v-card-text class="pb-2">
          <v-divider class="my-4"></v-divider>
          <div class="text-right">
            <div class="grey--text text--darken-1 mb-2">
              <v-icon>mdi-circle-medium</v-icon><b>نام خریدار:</b>
              {{ selected.userName }}
            </div>
            <div class="grey--text text--darken-1 mb-2">
              <v-icon>mdi-circle-medium</v-icon><b>نام محصول:</b>
              {{ selected.productName }}
            </div>
            <div class="grey--text text--darken-1 mb-2">
              <v-icon>mdi-circle-medium</v-icon><b>قیمت محصول:</b>
              {{ selected.price ? selected.price.toLocaleString() : 0 }} تومان
            </div>
            <div class="grey--text text--darken-1 mb-5">
              <v-icon>mdi-circle-medium</v-icon><b>تاریخ خرید:</b>
              {{ selected.date }}
            </div>
            <div class="grey--text text--darken-1 mb-4">
              <v-text-field
                v-model="selected.amount"
                placeholder="تعداد خریداری شده"
                label="تعداد خریداری شده"
                outlined
                hide-details
                dense
              ></v-text-field>
            </div>
            <div class="fs-large teal--text text--darken-1 mb-5">
              <b>مبلغ کل:</b>
              {{ (selected.price * selected.amount).toLocaleString() }} تومان
            </div>

            <b class="grey--text text--darken-4 fs-medium">
              آیا از تایید درخواست ثبت شده اطمینان دارید؟
            </b>
          </div>

          <div class="text-left pt-4">
            <v-btn
              width="80"
              height="42"
              class="rounded-lg teal me-3 white--text"
              @click="confirmApprove()"
              :loading="loading"
              ><v-icon small class="me-2">mdi-check-underline</v-icon>بله</v-btn
            >
            <v-btn
              width="80"
              height="42"
              class="rounded-lg error"
              @click="approveDialog = false"
              ><v-icon small class="me-2">mdi-close</v-icon>خیر</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Dialog for reject confirmation -->
    <v-dialog v-model="rejectDialog" width="600">
      <v-card class="modal-card">
        <v-card-title class="py-0">
          <div class="text-right fs-xlarge grey--text text--darken-3">
            رد درخواست خرید
          </div>
        </v-card-title>
        <v-card-text class="pb-2">
          <v-divider class="my-4"></v-divider>
          <div class="text-right">
            <div class="grey--text text--darken-1 mb-2">
              <v-icon>mdi-circle-medium</v-icon><b>نام خریدار:</b>
              {{ selected.userName }}
            </div>
            <div class="grey--text text--darken-1 mb-2">
              <v-icon>mdi-circle-medium</v-icon><b>نام محصول:</b>
              {{ selected.productName }}
            </div>
            <div class="grey--text text--darken-1 mb-5">
              <v-icon>mdi-circle-medium</v-icon><b>تاریخ خرید:</b>
              {{ selected.date }}
            </div>

            <b class="grey--text text--darken-4 fs-medium">
              آیا از رد درخواست ثبت شده اطمینان دارید؟
            </b>
          </div>

          <div class="text-left pt-4">
            <v-btn
              width="80"
              height="42"
              class="rounded-lg teal me-3 white--text"
              @click="rejectApprove()"
              :loading="loading"
              ><v-icon small class="me-2">mdi-check-underline</v-icon>بله</v-btn
            >
            <v-btn
              width="80"
              height="42"
              class="rounded-lg error"
              @click="rejectDialog = false"
              ><v-icon small class="me-2">mdi-close</v-icon>خیر</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Request Information -->
    <v-dialog v-model="requestInfoDialog" width="600">
      <v-card class="modal-card">
        <v-card-title class="py-0 d-flex justify-space-between">
          <div>اطلاعات درخواست</div>
          <div>
            <span
              ><v-icon
                small
                class="red--text pointer"
                @click="requestInfoDialog = false"
                >mdi-close</v-icon
              ></span
            >
          </div>
        </v-card-title>
        <v-card-text class="pb-1">
          <v-divider class="my-4"></v-divider>
          <div class="text-right">
            <v-row class="py-5">
              <v-col cols="6" class="pb-3">
                <span class="font-weight-bold">نام و نام خانوادگی: </span>
                <span>{{ selectedRequest.name }}</span>
              </v-col>
              <v-col cols="6" class="pb-3">
                <span class="font-weight-bold">وضعیت مخاطب: </span>
                <span>{{
                  activityTypes.filter(
                    (a) => a.value == selectedRequest.businessType
                  )[0]
                    ? activityTypes.filter(
                        (a) => a.value == selectedRequest.businessType
                      )[0].text
                    : "-"
                }}</span>
              </v-col>

              <v-col
                cols="6"
                class="py-3"
                v-if="
                  selectedRequest.businessType &&
                  selectedRequest.businessType == 'company'
                "
              >
                <span class="font-weight-bold">نام حقوقی: </span>
                <span>{{ selectedRequest.legalName }}</span>
              </v-col>
              <v-col cols="6" class="py-3">
                <span class="font-weight-bold">سمت اجرایی: </span>
                <span>{{ selectedRequest.registrantPosition }}</span>
              </v-col>

              <v-col cols="12" class="py-3">
                <v-row>
                  <v-col cols="6" class="py-3">
                    <span class="font-weight-bold">استان: </span>
                    <span>{{
                      selectedRequest.state ? selectedRequest.state : "-"
                    }}</span>
                  </v-col>
                  <v-col cols="6" class="py-3">
                    <span class="font-weight-bold">شهر: </span>
                    <span>{{
                      selectedRequest.city ? selectedRequest.city : "-"
                    }}</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6" class="py-3">
                <span class="font-weight-bold">موبایل: </span>
                <span>{{ selectedRequest.mobile }}</span>
              </v-col>

              <v-col cols="12" class="py-3">
                <span class="font-weight-bold">ایمیل: </span>
                <span>{{ selectedRequest.email }}</span>
              </v-col>

              <v-col cols="12" class="py-3">
                <span class="font-weight-bold">توضیحات: </span>
                <span>{{ selectedRequest.description }}</span>
              </v-col>

              <v-col cols="12">
                <span class="font-weight-bold">نحوه آشنایی: </span>
                <span>{{ selectedRequest.acquaintanceMethod }}</span>
              </v-col>
            </v-row>
          </div>
          <v-divider class="pt-3 mt-3"></v-divider>
          <div class="text-left pt-4" v-if="selected.status == 'pending'">
            <v-btn
              width="80"
              height="42"
              class="rounded-lg teal me-3 white--text"
              @click="approvedRequest()"
              :loading="loading"
              ><v-icon small class="me-2">mdi-check-underline</v-icon
              >تایید</v-btn
            >
            <v-btn
              width="80"
              height="42"
              class="rounded-lg error"
              @click="rejectRequest()"
              ><v-icon small class="me-2">mdi-close</v-icon>رد</v-btn
            >
          </div>
          <div class="text-left" v-else>
            <v-btn
              width="80"
              height="42"
              class="rounded-lg error"
              @click="requestInfoDialog = false"
              ><v-icon small class="me-2">mdi-close</v-icon>بستن</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tab: null,
      PerPage: 10,
      CurrentPage: 1,
      PerPageConsultation: 10,
      CurrentPageConsultation: 1,
      PerPageRequests: 10,
      CurrentPageRequests: 1,
      headers: [
        { text: "نام خریدار", sortable: false, value: "userName" },
        { text: "موبایل", sortable: false, value: "userMobile" },
        { text: "نام محصول", sortable: false, value: "productName" },
        { text: "قیمت محصول", sortable: false, value: "price" },
        { text: "تعداد", sortable: false, value: "amount" },
        { text: "تاریخ خرید", sortable: false, value: "date" },
        { text: "وضعیت", sortable: false, value: "status" },
        { text: "عملیات", sortable: false, value: "actions" },
      ],
      headersConsultation: [
        { text: "نام", sortable: false, value: "name" },
        { text: "توضیح", sortable: false, value: "desciption" },
        { text: "عملیات", sortable: false, value: "actions" },
      ],
      headersRequest: [
        { text: "نام", sortable: false, value: "name" },
        { text: "نوع فعالیت", sortable: false, value: "businessType" },
        { text: "وضعیت", sortable: false, value: "status" },
        { text: "عملیات", sortable: false, value: "actions" },
      ],

      activityTypes: [
        { text: "شخصی", value: "personal" },
        { text: "استارت آپ", value: "startup" },
        { text: "شرکت حقوقی", value: "company" },
      ],
      statuses: [
        { text: "در حال بررسی", value: "pending" },
        { text: "تایید شده", value: "approved" },
        { text: "رد شده", value: "rejected" },
      ],

      activityTypes: [
        { text: "شخصی", value: "personal" },
        { text: "استارت آپ", value: "startup" },
        { text: "شرکت حقوقی", value: "company" },
      ],

      purchases: [],
      consultations: [],
      requests: [],
      searchField: "",
      tableLoading: false,
      approveDialog: false,
      approveConsultationDialog: false,
      rejectDialog: false,
      selected: {},
      selectedRequest: {},
      loading: false,
      requestInfoDialog: false,
    };
  },

  methods: {
    getConsultations() {
      this.tableLoading = true;
      this.$http
        .get(this.baseUrl + "/admin/consultations/list", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        })

        .then((res) => {
          if (res.status == 200) {
            setTimeout(() => {
              this.consultations = res.data;
              this.tableLoading = false;
            }, 500);
          }
        })
        .catch((err) => {
          this.tableLoading = false;
          console.log(err);
          this.toast("Error: " + err.response.data, "error");
        });
    },
    getRequestInfo(item) {
      this.$http
        .get(this.baseUrl + "/admin/request/getData/" + item.id, {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        })

        .then((res) => {
          if (res.status == 200) {
            setTimeout(() => {
              this.selectedRequest = res.data;
              this.selected = item;
              this.requestInfoDialog = true;
              this.tableLoading = false;
            }, 500);
          }
        })
        .catch((err) => {
          this.tableLoading = false;
          console.log(err);
          this.toast("Error: " + err.response.data, "error");
        });
    },
    getRequests() {
      this.tableLoading = true;
      this.$http
        .get(this.baseUrl + "/admin/requests/list", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        })

        .then((res) => {
          if (res.status == 200) {
            setTimeout(() => {
              this.requests = res.data;
              this.tableLoading = false;
            }, 500);
          }
        })
        .catch((err) => {
          this.tableLoading = false;
          console.log(err);
          this.toast("Error: " + err.response.data, "error");
        });
    },
    getPurchases() {
      this.tableLoading = true;
      this.$http
        .get(this.baseUrl + "/admin/invoices/list", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        })

        .then((res) => {
          if (res.status == 200) {
            setTimeout(() => {
              this.purchases = res.data;
              this.tableLoading = false;
            }, 500);
          }
        })
        .catch((err) => {
          this.tableLoading = false;
          console.log(err);
          this.toast("Error: " + err.response.data, "error");
        });
    },

    computedText(text) {
      if (this.searchField) {
        return text.replace(new RegExp(this.searchField, "ig"), (match) => {
          return (
            '<span style="background-color: #0c626d; color:#fff; padding: 0 3px; border-radius: 4px">' +
            match +
            "</span>"
          );
        });
      } else {
        return text;
      }
    },

    openApproveDialog(item) {
      this.selected = JSON.parse(JSON.stringify(item));
      this.approveDialog = true;
    },
    openConsultationApproveDialog(item) {
      this.selected = JSON.parse(JSON.stringify(item));
      this.approveConsultationDialog = true;
    },

    confirmApprove() {
      this.loading = true;
      this.$http
        .patch(
          this.baseUrl + "/admin/invoice/approve/" + this.selected.id,
          {
            amount: this.selected.amount,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )

        .then((res) => {
          if (res.status == 200) {
            this.loading = false;
            this.approveDialog = false;
            this.getPurchases();
            this.toast(res.data.message, "success");
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          this.toast("Error: " + err.response.data, "error");
        });
    },

    openRejectDialog(item) {
      this.selected = JSON.parse(JSON.stringify(item));
      this.rejectDialog = true;
    },

    rejectApprove() {
      this.loading = true;
      this.$http
        .patch(
          this.baseUrl + "/admin/invoice/reject/" + this.selected.id,
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )

        .then((res) => {
          if (res.status == 200) {
            this.loading = false;
            this.rejectDialog = false;
            this.getPurchases();
            this.toast(res.data.message, "success");
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          this.toast("Error: " + err.response.data, "error");
        });
    },

    approvedRequest() {
      this.$http
        .patch(
          this.baseUrl + "/admin/request/approve/" + this.selected.id,
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.requestInfoDialog = false;
            this.getRequests();
            this.toast(res.data, "success");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    rejectRequest() {
      this.$http
        .patch(
          this.baseUrl + "/admin/request/reject/" + this.selected.id,
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.requestInfoDialog = false;
            this.getRequests();
            this.toast(res.data, "success");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
  },
  computed: {
    computedPurchases() {
      let filtered = this.purchases.filter(
        (x) =>
          x.userName.includes(this.searchField) ||
          x.userMobile.includes(this.searchField) ||
          x.date.includes(this.searchField) ||
          x.status.includes(this.searchField) ||
          x.productName.includes(this.searchField)
      );
      return filtered;
    },
    computedConsultation() {
      let filtered = this.consultations.filter((x) =>
        x.name.includes(this.searchField)
      );
      return filtered;
    },
    computedRequests() {
      let filtered = this.requests
        ? this.requests.filter((x) => x.name.includes(this.searchField))
        : [];
      return filtered;
    },
  },

  mounted() {
    this.getPurchases();
    this.getRequests();
  },
};
</script>

<style lang="scss" scoped></style>
